<template>
    <div>
        <defNavBar title="Ares - Chat info" :home=true />
        <v-main>
            <v-row class="mt-8">
                <v-col cols="6" offset="1">
                    <h3>Current location: {{ getLocation() }}</h3>
                    <h3>Ares is running in: {{ getModus() }}</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="7" offset="1">
                    <h3>Chat {{ chat.chatnr }} info</h3>
                    <v-divider class="mb-2 mt-2"></v-divider>
                    <h4 class="mb-4">Booking: {{ chat.huov_code }}</h4>
                    <div v-for="member in chat.urls" :key="member.key">
                        <div class="flex">
                            <div class="col1">{{ member.member }}</div>
                            <div class="col2">{{ member.name }}</div>
                            <div class="col3">{{ member.code }}</div>
                            <div class="col3">{{ member.language }}</div>
                            <div class="col3 ml-2">Unread: <span class="ml-2">{{ member.unread }}</span></div>
                            <div class="col3 ml-2">Sent: <span class="ml-2">{{ member.send }}</span></div>
                        </div>
                    </div> 
                    <h4 class="mt-2">Chats: {{ chat.chats }} </h4>
                </v-col>
            </v-row>        
            <v-row v-if="modus==='DEV'">
                <v-col cols="11" offset="1">
                    <div class="flex">
                        <div><h3>Open chat as</h3></div>
                        <div v-for="url in chat.urls" :key="url.key">
                            <v-btn @click="openUrl(url.key)" class="ml-3"><v-icon>mdi-account</v-icon>{{ url.member }}</v-btn> 
                        </div>
                    </div>
                </v-col>    
            </v-row>
            <v-row v-else>
                <v-col cols="11" offset="1">
                    <div class="flex">
                        <div><h3>Open chat as</h3></div>
                        <div v-for="url in chat.urls" :key="url.key">                    
                            <v-btn @click="openUrl(url.key)" class="ml-3"><v-icon>mdi-account</v-icon>{{ url.member }}</v-btn>                     
                        </div>
                    </div>
                </v-col>    
            </v-row>    
        </v-main>
    </div>
</template>

<script>
    import defNavBar from '@/components/ui/navbars/navbar.vue';
    export default {
        mounted(){
            this.getUrls();
        },
        props: {
            param: String,
        },            
        components:{
            defNavBar
        },
        data() {
            return {
                modus: this.getModus(),
                huov_code: '',
                chat: {},
            }
        },
        created(){
            window.addEventListener("focus", this.focusEventHandler);
        },
        destroyed() {
            window.removeEventListener("focus", this.focusEventHandler);
        },        
        methods: { 
            openUrl(key){
                if(this.getModus()==='DEV'){
                    window.open("http://46.17.3.95:8082/messaging/" + key, '_blank')
                } else{
                    window.open("https://www.villaforyou.info/messaging/" + key, '_blank')
                }
            },
            getLocation(){
                let x = `${window.location}`; 
                return x.slice(0, x.indexOf("/h"));
            },
            getModus(){
                let x = `${window.location}`;
                return x.indexOf('https://')!==-1?'PROD':'DEV';
            },
            focusEventHandler() {
                this.getUrls();            
            },            
            getUrls(){
                this.$axios
                    .post("ares/json/ares/huov/mstr/getChatUrlByHuov.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getChatData"
                        },
                        getChatData: {
                            mstrcode: this.param
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            this.chaturl = [];
                            document.title=`Chat Info`;
                        } else {                   
                            console.log(res.data);
                            this.chat = res.data.getChatData;
                            document.title=`Chat Info ${this.chat.huov_code}`;
                        }
                    });   
            },                      
        }
    }
</script>

<style scoped>
.flex{
    display:flex;
    flex-direction: row;
    align-items: center;
    font-weight: 700 !important;
}
.col1{
    width: 11vw;
}
.col2{
    width: 15vw;
}
.col3{
    width: 5vw;
}
</style>